import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { WorkListCard } from './WorkListCard';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class WorkListScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_PRESENCES_WORKS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_PRESENCIA_DE_TRABAJADORES_EN_OBRAS')} breadcrumbs={breadcrumbs}>
                <WorkListCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/work/WorkListScreen.jsx